import React,{useState} from 'react'
import {AiOutlinePlus} from 'react-icons/ai'
import { Formik } from 'formik'
import { CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import MainLayout from '../../Component/MainLayout/MainLayout'
import PaddingLayout from '../../Component/MainLayout/PaddingLayout'
import {Field, TextAndField, FillButton, Text} from '../../Component/FormUtils/FormUtils'
import { DataTable } from './DataTable'
import { uploadFile } from '../../Network/ServiceClass/File'
import { presidentSchema } from '../../Component/validationSchema'
import { createPresidentThunk } from '../../Store/president'
import Error from '../../Component/Errors/Error'

const President = () => {
    const dispatch = useDispatch()
    const store = useSelector((state) => state.president);

    const [photo, setPhoto] = useState(null)
    const [publicId, setPublicId] = useState(null)
    const [isFileLoading, setIsFileLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [errMsg, setErrMsg] = useState('')

    const handlePhoto = (e) => {
        setIsFileLoading(true)
        const file = e.target.files[0]
        const formdata = new FormData();
        formdata.append('file', file);
        uploadFile(formdata).then(val => {
            setIsFileLoading(false)
            setPhoto(val.data.secureUrl)
            setPublicId(val.data.publicID)
            toast.success('Photo uploaded')

        }).catch(err => {
            console.log(err)
            setIsFileLoading(false)

        })
    }

    const handleSubmit = (values, actions) => {
        const data = {
            message: values.message,
            name: values.name,
            photo: {
                publicID: publicId,
                secureUrl: photo
            }

        }
        if(photo === null){
            setIsError(true)
            setErrMsg('You have to select an image')
        }else{
            dispatch(createPresidentThunk(data))
            .then(()=>{
                actions.resetForm()
                toast.success('president created')
            })
        }
    }
  return (
    <MainLayout presentLink={'president'}>
        <PaddingLayout>
            <div className='flex flex-col gap-3'>

                <div className='p-4 rounded-sm flex flex-col gap-5 bg-[white]'>
                    <p className='text-[18px]'>Add President</p>

                    <Formik 
                    initialValues={{
                        message: '',
                        name: '',
                        from: '',
                        to: ''
                    }}
                    validationSchema={presidentSchema}
                    onSubmit={(values,actions)=> handleSubmit(values,actions)}>
                        {props => (
                            <div className='flex flex-col gap-4'>

                                <div className='flex gap-10'>
                                    <TextAndField>
                                        <Text text={'Name'}/>
                                        <Field size='small' conWidth='500px'  name='name' placeholder='Enter Name'/>
                                    </TextAndField>

                                    

                                    <div className='flex items-center gap-2'>
                                        <TextAndField>
                                            <Text text={'Browse Image'}/>
                                            <input className='border-1 rounded-md p-1 border-color' type={'file'} onChange={(e)=>handlePhoto(e)}  placeholder='upload image'/>
                                        </TextAndField>
                                        {isFileLoading && <CircularProgress size={'20px'} className='mt-[20px]'/>}
                                    </div>


                                   
                                </div>
                                <Field size='small' multiline={true} maxRows={4} conWidth='940px' name='message' placeholder='Message'/>

                                <div className='flex flex-row gap-3'>

                                    <TextAndField>
                                        <Text text={'From'}/>
                                        <Field size='small' type={'date'} conWidth='150px'  name='from' />
                                    </TextAndField>

                                    <TextAndField>
                                        <Text text={'To'}/>
                                        <Field size='small' type={'date'} conWidth='150px'  name='to' />
                                    </TextAndField>
                                </div>

                                <div className='flex gap-2'>
                                    <FillButton width={'150px'} text={'Add'} isLoading={store.createPresidentLoading} callBack={props.handleSubmit}/>

                                    {isError && <Error message={errMsg} handleClick={()=>setIsError(false)}/>}
                                </div>
                            </div>
                        )}
                    </Formik>
                    <div>

                    </div>
                </div>
                <div className='bg-[white] p-3 rounded-sm'><DataTable/></div>
                
                
            </div>

        </PaddingLayout>

    </MainLayout>
  )
}

export default President